// Func = limiting Scope for this file
var lastScrollTop = 0;


(function(){

	$(document).ready(function () {

		$('.fancybox').fancybox();
		//Call function with browser is resized.
		$(window).resize(function (event) {
			//resizeWindow();

		});
		//resizeWindow();

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			//scrollDown();
		});

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		// Main Nav Dropdown
		$("#primary-nav2 li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn, #CheckIn-alt').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut, #CheckOut-alt').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn, #CheckIn-alt").data("format") !== undefined && $("#CheckIn, #CheckIn-alt").data("format")) ? $("#CheckIn, #CheckIn-alt").data("format") : "yy-mm-dd";
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				$( "#CheckIn-alt" ).val(newDate.getFullYear() + '' + ((newDate.getMonth() + 1) < 10 ? "0" + (newDate.getMonth() + 1) : (newDate.getMonth() + 1) ) + '' + ( newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate() ));
				newDate.setDate(newDate.getDate() + 3);
				console.log(newDate);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut-alt" ).val(newDate.getFullYear() + '' + ((newDate.getMonth() + 1) < 10 ? "0" + (newDate.getMonth() + 1) : (newDate.getMonth() + 1) ) + '' + ( newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate() ));
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				$( "#CheckOut-alt" ).val(newDate.getFullYear() + '' + ((newDate.getMonth() + 1) < 10 ? "0" + (newDate.getMonth() + 1) : (newDate.getMonth() + 1) ) + '' + ( newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate() ));
				console.log($( "#CheckOut-alt" ).val());
				//$( "#CheckIn, #CheckIn-alt" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

		//Modify content js
		$('#third-nav').removeAttr('aria-labelledby');
		/* $('#third-nav').removeAttr('aria-label');
		$('#third-nav').removeAttr('role');

		$('#primary-nav').removeAttr('aria-label');
		$('#primary-nav').attr('role', 'navigation primary');

		$('#secondary-nav').removeAttr('aria-label');
		$('#secondary-nav').removeAttr('role'); */

		$('.shortcodes-content .slick-arrow').removeAttr('aria-label');

		$('#email-signup a').removeAttr('aria-label');

		

	
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());


var isInternalPages = document.querySelector('#default, #gallery ,#map, #map-category, #attractions, body.sitemap,#page-blog-auto');
if(isInternalPages){ document.querySelector('.section-header__logo img').src = '/assets/svg/logo-green.svg';}

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
				document.querySelector('.section-header__logo img').src = '/assets/svg/logo-green.svg';
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
				document.querySelector('.section-header__logo img').src = '/assets/svg/logo-green.svg';
			}

		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
			document.querySelector('.section-header__logo img').src = '/assets/svg/logo.svg';
			if(isInternalPages){ document.querySelector('.section-header__logo img').src = '/assets/svg/logo-green.svg';};
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

	/* animate-clip animation */
	const window_height = window.innerHeight;
	let animatedEl = document.getElementsByClassName('animate-fade-2');
	for (let i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if(topPos <= window_height*0.8){
			animatedEl[i].classList.add('fade-in');
		}
	}
}

/* Open and close booking */
/*
document.querySelector('.header__booking-btn').addEventListener('click', function(){
	document.getElementById('booking-overlay').classList.add('active');
});
document.querySelector('#booking-overlay .lightbox__close').addEventListener('click', function(){
	document.getElementById('booking-overlay').classList.remove('active');
});
*/

//Slick Slider to pagination
	$(".slider").slick({
	    autoplay: true,
	    arrows: true,
	    dots: false,
		fade: true,
	    customPaging : function(slider, i) {
	    var thumb = $(slider.$slides[i]).data();
		return ''+i+'';
	    }
	});


	//custom function showing current slide
	var $status = $('.pagingInfo');
	var $slickElement = $('.slider');

		$slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
	    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
	    var i = (currentSlide ? currentSlide : 0) + 1;
	    $status.text(i);
	});

	if( $('.accommodations') ) {
		$('.accommodations').slick({
			nextArrow: document.getElementById('slick-next'),
			prevArrow: document.getElementById('slick-previous')
		});
	}

/*funtions to video bottom home page */
var vid = document.getElementById("bottomVideo");
var videoMute = document.getElementById("bottomVideo");


function playVid() { 
	vid.play();
	videoMute.muted = false;
	document.getElementById("playVideo").style.display = "none";
	document.getElementById("pauseyVideo").style.display = "block";
} 
function pauseVid() { 
	vid.pause();
	videoMute.muted = true;
	document.getElementById("playVideo").style.display = "block";
	document.getElementById("pauseyVideo").style.display = "none";
}

/* funtionality toggle */
	let slideUp = (target, duration=500) => {
	    target.style.transitionProperty = 'height, margin, padding';
	    target.style.transitionDuration = duration + 'ms';
	    target.style.boxSizing = 'border-box';
	    target.style.height = target.offsetHeight + 'px';
	    target.offsetHeight;
	    target.style.overflow = 'hidden';
	    target.style.height = 0;
	    target.style.paddingTop = 0;
	    target.style.paddingBottom = 0;
	    target.style.marginTop = 0;
	    target.style.marginBottom = 0;
	    window.setTimeout( () => {
		target.style.display = 'none';
		target.style.removeProperty('height');
		target.style.removeProperty('padding-top');
		target.style.removeProperty('padding-bottom');
		target.style.removeProperty('margin-top');
		target.style.removeProperty('margin-bottom');
		target.style.removeProperty('overflow');
		target.style.removeProperty('transition-duration');
		target.style.removeProperty('transition-property');
	    }, duration);
	}

	let slideDown = (target, duration=500) => {
	    target.style.removeProperty('display');
	    let display = window.getComputedStyle(target).display;

	    if (display === 'none')
	      display = 'block';

	    target.style.display = display;
	    let height = target.offsetHeight;
	    target.style.overflow = 'hidden';
	    target.style.height = 0;
	    target.style.paddingTop = 0;
	    target.style.paddingBottom = 0;
	    target.style.marginTop = 0;
	    target.style.marginBottom = 0;
	    target.offsetHeight;
	    target.style.boxSizing = 'border-box';
	    target.style.transitionProperty = "height, margin, padding";
	    target.style.transitionDuration = duration + 'ms';
	    target.style.height = height + 'px';
	    target.style.removeProperty('padding-top');
	    target.style.removeProperty('padding-bottom');
	    target.style.removeProperty('margin-top');
	    target.style.removeProperty('margin-bottom');
	    window.setTimeout( () => {
		target.style.removeProperty('height');
		target.style.removeProperty('overflow');
		target.style.removeProperty('transition-duration');
		target.style.removeProperty('transition-property');
	    }, duration);
	}

	var slideToggle = (target, duration = 500) => {
	    if (window.getComputedStyle(target).display === 'none') {
	    	return slideDown(target, duration);
	    } else {
	    	return slideUp(target, duration);
	    }
	}


/* end funtionality toggle */

	/*First Name input */
	var inputFNAME = document.createElement("input");
		inputFNAME.setAttribute("type", "hidden");
		inputFNAME.setAttribute("name", "mailchimp[FNAME]");
		inputFNAME.setAttribute("value", "first_name");

	/*Last Name input*/
	var inputLNAME = document.createElement("input");
		inputLNAME.setAttribute("type", "hidden");
		inputLNAME.setAttribute("name", "mailchimp[LNAME]");
		inputLNAME.setAttribute("value", "last_name");

	/*Email Address input*/
	var inputADDRESS = document.createElement("input");
		inputADDRESS.setAttribute("type", "hidden");
		inputADDRESS.setAttribute("name", "mailchimp[ADDRESS]");
		inputADDRESS.setAttribute("value", "email_address");

	// var inputSOURCE = document.createElement("input");
	// 	inputSOURCE.setAttribute("type", "hidden");
	// 	inputSOURCE.setAttribute("name", "mailchimp[SOURCE]");
	// 	inputSOURCE.setAttribute("value", "source");



	//append to form element added
	document.getElementById("email-signup").append(inputFNAME, inputLNAME, inputADDRESS);

	
//var mql = window.matchMedia("(orientation: portrait)");
//var mql2 = window.matchMedia("(orientation: landscape)");
/* If there are matches, we're in portrait */
//if(mql.matches || mql2.matches) {

	/* Menu to Ipad portraid version */

//	var menuBg = document.createElement("a");
//	var element = document.querySelector("ul#privary-navigation li.privary-navigation__item.primary-nav-4");
//	var parentDiv = element.parentNode;
//	menuBg.className = 'burger';
//	menuBg.setAttribute('id', 'burger-desktop');
//	menuBg.innerHTML = '<i>' + '</i>' + '<br>'+ '<span>Menu</span>';
//	parentDiv.insertBefore(menuBg, element);


//	let html = $( "ul#privary-navigation" ).html();
//	$( "#privary-navigation-2" ).html( html);
//	document.getElementById('primary-nav2').style.display = "none"
//	let burgerMenu = document.querySelector('.burger');

//	document.getElementById("burger-desktop").addEventListener('click', function() {
//		burgerMenu.classList.toggle('active-burger');
//		slideToggle(document.getElementById("primary-nav2"), 200);
//	});

	/* End Menu to Ipad portraid version */
//} 



